// extracted by mini-css-extract-plugin
export default {"locationSection":"locations_locationSection__Au1ov","fadeIn":"locations_fadeIn__J1G-d","locationsList":"locations_locationsList__FkGMc"};